import React, { useEffect, useState, version } from "react";
import { useLanguage } from "../../Translations/LenguageContext";
import { useNavigate, useParams } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { MdOutlineCheckCircle, MdOutlineCircle } from "react-icons/md";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const MainOpenApp = ({
    account_id,
    userData,
    setMcpData,
    mcpData,
    fetchMcpData,
    loadingMcpData
}) => {
    const { t } = useLanguage()
    const { org_id, mcp_id, version_n } = useParams()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });
    const [fields, setFields] = useState([]);
    const [formData, setFormData] = useState({});


    const handleStep1 = async () => {
        setLoading(true);
        setErrorMessage({ message: "", display: false });
        const redirect_uri = window.location.origin;
        // if (selectedMCP.id.startsWith("pub-abty")) {
        //     if(selectedMCP.id){
        //         setTimeout(() => {
        //             navigate(`/oauth/${org_id}/${selectedMCP.id}/${selectedMCP.version}`)
        //         }, 2000);
        //     }
        // } else {
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_custom_auth`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    account_id,
                    org_id,
                    email: userData.email,
                    mcp_id: mcp_id,
                    version: version_n,
                    redirect_uri
                }),
            });

            const result = await response.json();
            if (result.status == "success") {
                if (result.fields) {
                    setFields(result.fields);
                } else if (result.url) {
                    window.location.href = result.url;
                }
            }
        } catch (err) {
            setLoading(false);
            setErrorMessage({ message: "An error occurred. Please try again.", display: true });
            console.error("Step1 Error:", err);
        } finally {
            setLoading(false)
        }
        // }

    };

    const handleStep2 = async () => {
        setLoading(true);
        setErrorMessage({ message: "", display: false });

        const missingFields = fields
            .filter(f => f.required)
            .filter(f => {
                const value = formData[f.key];
                if (f.type === "multi-select" || f.type === "select") {
                    return !value || value.length === 0;
                }
                return !value || value === "";
            });

        if (missingFields.length > 0) {
            setErrorMessage({
                message: `${t.abilities.fill_field}: ${missingFields[0].label}`,
                display: true
            });
            setLoading(false);
            return;
        }


        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/connect_custom_mcp`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    account_id,
                    mcp_id,
                    version: version_n,
                    fields: formData
                }),
            });

            const result = await response.json();

            if (result.status === "success") {
                setLoading(false);
                fetchMcpData(org_id)
            } else {
                setErrorMessage({ message: result.message || t.abilities.failed_conn, display: true });
                setLoading(false);
            }
        } catch (err) {
            setErrorMessage({ message: t.abilities.failed_conn, display: true });
            setLoading(false);
            console.error("Step2 Error:", err);
        }
    };

    const handleFieldChange = (key, value) => {
        setFormData(prev => ({ ...prev, [key]: value }));
    };

    
    useEffect(() => {
        setErrorMessage({ message: "", display: false });
        setFields([]);
        setFormData({});
        handleStep1()
    }, []);

    return (
        <div className="mainframe_item">
            <div className="open_app">
                <div className="open_app_inner">
                    
                        {fields.map((field, index) => {
                            if (field.type === "select" || field.type === "multi-select") {
                                const options = field.options || [];
                                const selectedValues = formData[field.key] || [];

                                return (
                                    <div key={index} className="label_input">
                                        <label className="input_label">{field.label}</label>
                                        <Dropdown drop="up">
                                            <Dropdown.Toggle
                                                as="div"
                                                className="register_form_first fade-in pointer"
                                            >
                                                {selectedValues.length > 0
                                                    ? options
                                                        .filter(opt => selectedValues.includes(opt.value))
                                                        .map(opt => opt.label)
                                                        .join(", ")
                                                    : `Select`}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="custom_dropdown_menu">
                                                <div className="scrollable_dropdown_cont">
                                                    {options.map((opt) => {
                                                        const isSelected = selectedValues.includes(opt.value);

                                                        return (
                                                            <Dropdown.Item
                                                                key={opt.value}
                                                                onClick={() => {
                                                                    setFormData(prev => {
                                                                        if (field.type === "select") {
                                                                            // single-select: replace previous value
                                                                            return {
                                                                                ...prev,
                                                                                [field.key]: [opt.value]
                                                                            };
                                                                        } else {
                                                                            // multi-select: toggle value
                                                                            const alreadySelected = prev[field.key]?.includes(opt.value);
                                                                            return {
                                                                                ...prev,
                                                                                [field.key]: alreadySelected
                                                                                    ? prev[field.key].filter(v => v !== opt.value)
                                                                                    : [...(prev[field.key] || []), opt.value]
                                                                            };
                                                                        }
                                                                    });
                                                                }}
                                                                className="settings_link"
                                                            >
                                                                <i>
                                                                    {isSelected
                                                                        ? <MdOutlineCheckCircle />
                                                                        : <MdOutlineCircle />}
                                                                </i>
                                                                {opt.label}
                                                            </Dropdown.Item>
                                                        );
                                                    })}
                                                </div>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                );
                            }

                            return (
                                <div key={index} className="label_input">
                                    <label className="input_label">{field.label} <span>({field.endpoint})</span></label>
                                    <input
                                        type={field.type}
                                        autoComplete="off"
                                        maxLength={field.length || 200}
                                        value={formData[field.key] || ""}
                                        onChange={(e) => handleFieldChange(field.key, e.target.value)}
                                        className="register_form_first fade-in"
                                    />
                                </div>
                            );
                        })}
                       
                </div>
                <div className="open_app_inner"></div>
            </div>
        </div>
    )
}

export default MainOpenApp